import localforage from "localforage";

import { userTokenStorageKey } from "../../../config";
import { isEmpty } from "lodash";
import * as TYPES from "./mutations-types";
import * as services from "../services";
import { decode } from "jwt-simple";
import * as moment from "moment";

export const doLogin = ({ dispatch, commit }, payload) =>
    services.postLogin(payload).then(({ token, user }) => {
        dispatch("setUser", user);
        dispatch("setToken", token);

        services
            .getPermissions(token)
            .then((permissions) => {
                commit(TYPES.SET_PERMISSION, permissions);
            })
            .catch((err) => {
                // there are no permissions
                commit(TYPES.SET_PERMISSION, null);
            });

        return user; // keep promise chain
    });

export const logout = ({ commit }) => {
    services.revokeToken();
    // call actions
    commit(TYPES.TOKEN_EXPIRED);
};

export const setUser = ({ commit }, user) => {
    // Commit the mutations
    commit(TYPES.SET_USER, user);

    Promise.resolve(user); // keep promise chain
};

export const setToken = ({ commit }, payload) => {
    // prevent if payload is a object
    const token = isEmpty(payload) ? null : payload.token || payload;

    // Commit the mutations
    commit(TYPES.SET_TOKEN, token);

    return Promise.resolve(token); // keep promise chain
};

export const checkUserToken = ({ dispatch, state }) => {
    // If the token exists then all validation has already been done
    if (!isEmpty(state.token)) {
        return Promise.resolve(state.token);
    }

    /**
     * Token does not exist yet
     * - Recover it from localstorage
     * - Recover also the user, validating the token also
     */
    return (
        localforage
            .getItem(userTokenStorageKey)
            .then((token) => {
                if (isEmpty(token)) {
                    // Token is not saved in localstorage
                    return Promise.reject("NO_TOKEN"); // Reject promise
                }
                // Put the token in the vuex store
                return dispatch("setToken", token); // keep promise chain
            })
            // With the token in hand, retrieves the user's data, validating the token
            .then(() => dispatch("loadUser"))
    );
};

/**
 * Retrieves updated user information
 * If something goes wrong, the user's token is probably invalid
 */
export const loadUser = ({ dispatch }) =>
    services
        .loadUserData()
        // store user's data
        .then((user) => dispatch("setUser", user.data))
        .catch(() => {
            // Process failure, delete the token
            dispatch("setToken", "");
            return Promise.reject("FAIL_IN_LOAD_USER"); // keep promise chain
        });

export const refreshToken = ({ state, dispatch, commit }) => {
    if (!isEmpty(state.token) && !state.refreshing_token) {
        var invalid = false;
        var about_to_expire = false;

        try {
            var decodedToken = decode(
                state.token,
                process.env.VUE_APP_ROOT_JWT_KEY
            );

            var expires = moment(decodedToken.exp * 1000);

            // does it expire in less than 30 minutes?
            if (expires.isBefore(moment().add(30, "minutes"))) {
                about_to_expire = true;
            }
        } catch (err) {
            invalid = true;
        }
        if (!invalid && about_to_expire) {
            commit(TYPES.REFRESH_TOKEN); // Only refresh once

            services
                .refreshToken(state.token)
                .then(({ token, user }) => {
                    dispatch("setUser", user);
                    dispatch("setToken", token);

                    commit(TYPES.DONE_REFRESH_TOKEN);
                    return user; // keep promise chain
                })
                .catch(function (err) {
                    commit(TYPES.DONE_REFRESH_TOKEN);
                    return err;
                });
        }
    }
};
